const isThenable = (v) => v != null && typeof v.then === 'function';
/**
 * `redux-promise-middleware` dispatches FAILURE but still returns a rejecting promise; that leaks
 * and triggers dev overlays (“Uncaught runtime errors”). Toasts are shown once from the shared
 * `cmsHttp` axios error interceptor; this outer middleware only swallows the rejection.
 *
 * Registered as the first middleware so it wraps the composed dispatch chain.
 */
export const cmsSwallowDispatchedPromiseMiddleware = () => next => (action) => {
    const result = next(action);
    if (!isThenable(result)) {
        return result;
    }
    return result.catch(() => undefined);
};
